module.exports = __webpack_public_path__ + "static/media/Trustpilot.85ce0803.png";